'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.fullScreenControlWidget = function (navigatorModel) {
	return mmWidgets.each(this, function () {
		const element = this;
		if (navigatorModel.fullScreenEnabled()) {
			element.on('click', function (e) {
				const targetSelector = e.currentTarget && e.currentTarget.getAttribute('data-mm-target-selector');
				navigatorModel.requestFullScreen(document.querySelector(targetSelector));
			});
		} else {
			element.addClass('hidden');
		}
	});
};
